'use client';
import BlogCardPrimary from "@/components/shared/cards/BlogCardPrimary";
import Nodata from "@/components/shared/no-data/Nodata";
import {useLocale, useTranslations} from 'next-intl';
import {usePaginatedQuery} from '@/libs/api/baseRequests';
import {GET_BLOGS_QUERY} from '@/graphql/queries';
import {BlogsPaginatedTake} from '@/libs/constants/common.constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import BlogSkeletonList from '@/components/sections/blogs/skeleton/BlogSkeletonList';

export default function BlogsGridPrimary({blogs, options}) {
  const t = useTranslations('blog');
  const locale = useLocale();
  
  const { items, fetchMoreData, hasMore } = usePaginatedQuery(
      GET_BLOGS_QUERY,
      {locale, take: BlogsPaginatedTake, skip: 0},
      {...options, skipFirst: true},
      blogs,
  );
  
  return (
    <div className="ltn__blog-area ltn__blog-item-3-normal mb-100">
      <div className="container">
        {
          !items.length ? (
              <Nodata text={t('noBlogFound')} />
          ) : (
              <InfiniteScroll
                  dataLength={items.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  scrollThreshold={0.72}
                  style={{overflowX: 'hidden'}}
                  loader={
                    <div className="row g-4">
                      <BlogSkeletonList isGrid/>
                    </div>
                  }
              >
                <div className="row">
                  {
                    items.map((blog, idx) => (
                        <div key={idx} className="col-lg-4 col-sm-6 col-12">
                          <BlogCardPrimary blog={blog}/>
                        </div>
                    ))
                  }
                </div>
              </InfiniteScroll>
          )
        }
      </div>
    </div>
  );
};
